import { detailsComponents } from './school-details';

export const components: any[] = [
	...detailsComponents,
];

export * from './school-details';
